import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux'

import * as types from '../../../redux/constantes/user'
import {
  GetRegisterByCpfAction,
  ReSendSMSAction,
  UpdatePhoneAction,
  ValidateRegisterAction,
  VerifyRegisterAction
} from '../../../redux/actions/user'

import { MessageBoxAlert, MessageBoxError, MessageBoxSuccess } from '../../../components/MessageBox'
import { ContainerContent, ContainerTemplate } from '../../../components/Containers'
import { MenuSelect } from '../../../components/User/MenuSelect'
import { InputUser } from '../../../components/User/InputUser'
import { ButtonSend } from '../../../components/ButtonSend'
import { Header } from '../../../components/User/Header'
import { Title } from '../../../components/User/Title'

export const TemplateVerifyValidation: React.FC = () => {
  const {
    loading: loadingGetRegister,
    registerByCpf,
    error: errorGetRegister
  } = useSelector((state: RootStateOrAny) => state.getRegisterByCpf)
  const {
    loading: loadingVerify,
    status,
    error: errorVerify
  } = useSelector((state: RootStateOrAny) => state.verifyRegister)
  const {
    loading: loadingReSendSMS,
    success: successReSendSMS,
    error: errorReSendSMS
  } = useSelector((state: RootStateOrAny) => state.reSendSMS)
  const {
    loading: loadingUpdatePhone,
    success: successUpdatePhone,
    error: errorUpdatePhone
  } = useSelector((state: RootStateOrAny) => state.updatePhone)
  const {
    loading: loadingValidateRegister,
    success: successValidateRegister,
    error: errorValidateRegister
  } = useSelector((state: RootStateOrAny) => state.validateRegister)
  const dispatch = useDispatch()
  const history = useHistory()

  const [phone, setPhone] = useState('')
  const [code, setCode] = useState('')
  const [cpf, setCpf] = useState('')
  const [id, setId] = useState('')

  const [validatePhone, setValidatePhone] = useState(true)
  const [validateCode, setValidateCode] = useState(true)
  const [validateCpf, setValidateCpf] = useState(true)

  const [changeArea, setChangeArea] = useState('')

  const codeIsValid = () => {
    if (code === '') {
      setValidateCode(false)
    } else {
      setValidateCode(true)
    }
  }

  const cpfIsValid = () => {
    const cpfRegex = /^\d{3}.\d{3}.\d{3}-\d{2}$/
    if (cpfRegex.test(cpf)) {
      setValidateCpf(true)
    } else {
      setValidateCpf(false)
    }
  }

  const phoneIsValid = () => {
    // eslint-disable-next-line no-useless-escape
    const phoneRegex = /^(?:\+)[5-5]{2}\s?(?:\()[0-9]{2}(?:\))\s?[0-9]{4,5}(?:-)[0-9]{4}$/
    if (phoneRegex.test(phone)) {
      setValidatePhone(true)
    } else {
      setValidatePhone(false)
    }
  }

  const disableValidadeButton = () => {
    if (validateCpf && validateCode && code.length !== 0) {
      return false
    } else {
      return true
    }
  }

  const disableCPFButton = () => {
    if (cpf.length !== 0 || validateCpf === false) {
      return false
    } else {
      return true
    }
  }

  const accessValidationArea = () => {
    dispatch(GetRegisterByCpfAction(cpf))
    dispatch(VerifyRegisterAction(cpf))
  }

  const onValidate = () => {
    dispatch(ValidateRegisterAction(code))
  }

  const onReSendSms = () => {
    dispatch(ReSendSMSAction(phone))
  }

  const onUpdatePhone = () => {
    dispatch(UpdatePhoneAction(phone, id))
  }

  useEffect(() => {
    if (cpf.length === 14) {
      cpfIsValid()
    }
  }, [cpf])

  useEffect(() => {
    if (registerByCpf) {
      setPhone(registerByCpf.cellPhone)
      setId(registerByCpf._id)
    }
  }, [registerByCpf])

  useEffect(() => {
    if (successReSendSMS) {
      setTimeout(() => {
        dispatch({ type: types.RESEND_SMS_RESET })
        history.push('/validar-codigo')
      }, 3000)
    }
    if (successUpdatePhone) {
      setTimeout(() => {
        dispatch({ type: types.UPDATE_PHONE_RESET })
        history.push('/validar-codigo')
      }, 3000)
    }
    if (successValidateRegister) {
      setTimeout(() => {
        dispatch({ type: types.VALIDATE_REGISTER_RESET })
        history.push('/cadastro-realizado')
      }, 3000)
    }
    if (errorGetRegister) {
      setTimeout(() => {
        dispatch({ type: types.GET_REGISTER_BY_CPF_RESET })
      }, 5000)
    }
    if (errorVerify) {
      setTimeout(() => {
        dispatch({ type: types.VERIFY_REGISTER_RESET })
      }, 5000)
    }
    if (errorReSendSMS) {
      setTimeout(() => {
        dispatch({ type: types.RESEND_SMS_RESET })
      }, 5000)
    }
    if (errorUpdatePhone) {
      setTimeout(() => {
        dispatch({ type: types.UPDATE_PHONE_RESET })
      }, 5000)
    }
    if (errorValidateRegister) {
      setTimeout(() => {
        dispatch({ type: types.VALIDATE_REGISTER_RESET })
      }, 5000)
    }
  }, [
    errorGetRegister,
    errorVerify,
    errorReSendSMS,
    errorUpdatePhone,
    errorValidateRegister,
    successReSendSMS,
    successUpdatePhone,
    successValidateRegister
  ])

  return (
    <ContainerTemplate>
      <Header />
      <ContainerContent>
        <Title text="Digite o seu CPF para verificar o status do seu pré-cadastro" />
        <InputUser
          label={`CPF ${!validateCpf ? '(Campo obrigatório esta em branco ou incorreto)' : ''}`}
          onBlur={cpfIsValid}
          onChange={e => setCpf(e.target.value)}
          placeholder="exemplo: 123.456.789-00"
          value={cpf}
          isValidate={validateCpf}
          disabled={status === false && true}
        />
        <ButtonSend nameButton="Acessar" disabled={disableCPFButton()} onClick={accessValidationArea} />
        {loadingGetRegister && <MessageBoxAlert>Carregando Dados!</MessageBoxAlert>}
        {loadingVerify && <MessageBoxAlert>Verificando Validação!</MessageBoxAlert>}
        {status === false && (
          <>
            <MenuSelect setChangeArea={setChangeArea} />
            {changeArea === 'Validar Código' && (
              <>
                <InputUser
                  label={`Código de Validação ${
                    !validateCode ? '(Campo obrigatório esta em branco ou incorreto)' : ''
                  }`}
                  onBlur={codeIsValid}
                  onChange={e => setCode(e.target.value)}
                  placeholder="exemplo: sVBUXKNBck"
                  value={code}
                  isValidate={validateCode}
                  disabled={status}
                />
                {!loadingValidateRegister ? (
                  <ButtonSend nameButton="Validar código" disabled={disableValidadeButton()} onClick={onValidate} />
                ) : (
                  <ButtonSend nameButton="Carregando..." disabled={true} />
                )}
              </>
            )}
            {changeArea === 'Alterar Celular' && (
              <>
                <InputUser
                  label={`Celular ${!validatePhone ? '(Campo obrigatório esta em branco ou incorreto)' : ''}`}
                  onBlur={phoneIsValid}
                  onChange={e => setPhone(e.target.value)}
                  placeholder="exemplo: +55 (11) 98888-8888"
                  value={phone}
                  isValidate={validatePhone}
                  disabled={status}
                />
                {!loadingUpdatePhone ? (
                  <ButtonSend nameButton="Alterar Celular e enviar SMS" disabled={status} onClick={onUpdatePhone} />
                ) : (
                  <ButtonSend nameButton="Alterando seus dados e enviando SMS..." disabled={true} />
                )}
                <MessageBoxAlert>Você poderá alterar o seu celular apenas 3 vezes.</MessageBoxAlert>
              </>
            )}
            {changeArea === 'Re-enviar Código' && (
              <>
                {!loadingReSendSMS ? (
                  <ButtonSend nameButton="Re-enviar código" disabled={status} onClick={onReSendSms} />
                ) : (
                  <ButtonSend nameButton="Re-enviando SMS..." disabled={true} />
                )}
                <MessageBoxAlert>Você poderá re-enviar apenas 3 vezes.</MessageBoxAlert>
              </>
            )}
          </>
        )}
        {status && <MessageBoxSuccess>Você já esta validado!</MessageBoxSuccess>}
        {successReSendSMS && <MessageBoxSuccess>{successReSendSMS}</MessageBoxSuccess>}
        {successUpdatePhone && <MessageBoxSuccess>{successUpdatePhone}</MessageBoxSuccess>}
        {successValidateRegister && <MessageBoxSuccess>{successValidateRegister}</MessageBoxSuccess>}

        {errorVerify && <MessageBoxError>{errorVerify}</MessageBoxError>}
        {errorReSendSMS && <MessageBoxError>{errorReSendSMS}</MessageBoxError>}
        {errorUpdatePhone && <MessageBoxError>{errorUpdatePhone}</MessageBoxError>}
        {errorValidateRegister && <MessageBoxError>{errorValidateRegister}</MessageBoxError>}
      </ContainerContent>
    </ContainerTemplate>
  )
}
